import { Link } from "react-router-dom";
import LoadingSpinner from "../LoadingSpinner";
import style from "./index.module.css";

const index = ({
  buttonType = "button",
  styleType,
  children,
  onClick,
  onClickProps,
  linkTo,
  disabled = false,
  isLoading = false,
  extraProps,
}: ComponentPropsType) => {
  return buttonType === "link" ? (
    <Link
      className={`${style.button} ${style[styleType]}`}
      to={linkTo as string}
    >
      {children}
    </Link>
  ) : (
    <button
      type={buttonType}
      className={`${style.button} ${style[styleType]}`}
      onClick={(e) =>
        onClick ? (onClickProps ? onClick(e, onClickProps) : onClick(e)) : null
      }
      disabled={isLoading || disabled}
      {...(extraProps ? extraProps : {})}
    >
      {isLoading ? <LoadingSpinner /> : children}
    </button>
  );
};

export default index;

export type StyleType = "primary" | "primary_black" | "secondary" | "publish";

export type ComponentPropsType = {
  styleType: StyleType;
  children: any;
  buttonType?: "submit" | "button" | "reset" | "link";
  onClick?: any;
  onClickProps?: any;
  linkTo?: string;
  disabled?: boolean;
  isLoading?: boolean;
  extraProps?: any;
};
